<template>
    <div v-if="hasReports">
        <div class="responsive-table mt-5">
            <table class="table">
                <thead>
                    <tr>
                        <th>Status</th>
                        <th>URL</th>
                        <th>Hora</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="report in reports" :key="report.id">
                        <td>{{ formattedStatus(report) }}</td>
                        <td>
                            <a v-if="report.outputUrl" :href="report.outputUrl" target="_blank">Acessar</a>
                            <em v-else-if="report.status != 'failed'">Aguarde</em>
                        </td>
                        <td>{{ formattedDate(report) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <em v-else-if="isLoading">Carregando...</em>
    <em v-else>Você ainda não possui nenhum relatório exportado.</em>
</template>

<script>
import { requestJson } from '../helpers';
import moment from 'moment';

moment.locale('pt-br');

const statuses = {
    'queued': 'Na fila',
    'started': 'Gerando...',
    'succeeded': 'Finalizado',
    'failed': 'Falha',
};

export default {
    props: {
        reportsUrl: String,
    },
    data(){
        return {
            isLoading: true,
            reports: [],
            intervalRef: null,
        };
    },
    computed: {
        hasReports(){
            return this.reports.length > 0;
        },
    },
    methods: {
        async refreshReports(){
            this.reports = await requestJson(this.reportsUrl);
            this.isLoading = false;
        },
        formattedStatus(report){
            return statuses[report.status];
        },
        formattedDate(report){
            const dateTime = report.finishedAt ?? report.createdAt;
            return moment(dateTime).format('lll');
        },
    },
    mounted(){
        this.refreshReports();
        this.intervalRef = setInterval(() => this.refreshReports(), 3000);
    },
    beforeUnmount(){
        clearInterval(this.intervalRef);
    },
}
</script>

<style lang="scss">
</style>
